import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";
import Table from "components/Table";
import { budgetBuilderSelectors } from "store/selectors";
import { getLineItemsDirectCostTotal, getPeriodSubtotal } from "utils/budgetBuilder";

import styles from "./styles.css";


export const OverviewTotalDirectCosts = () => {
	const { currencyFormatter } = useTenantFormatter();
	const sponsoredCostsByPeriod = useSelector(budgetBuilderSelectors.sponsoredCostsByPeriod);
	const periodRows = useSelector(budgetBuilderSelectors.periodRows);
	const researchTeamByPeriod = useSelector(budgetBuilderSelectors.researchTeamByPeriod);

	const costsByPeriod = useMemo(
		() => {
			let result = {};
			for (let periodRow of periodRows) {
				result[periodRow.periodNumber] = getLineItemsDirectCostTotal(sponsoredCostsByPeriod[periodRow.periodNumber]);
				result[periodRow.periodNumber] += getPeriodSubtotal(researchTeamByPeriod[periodRow.periodNumber], false);
			}

			return result;
		},
		[ periodRows, sponsoredCostsByPeriod ]
	);
	const total = useMemo(
		() => Object.values(costsByPeriod).reduce((runningTotal, costForPeriod) => runningTotal + costForPeriod, 0),
		[ costsByPeriod ]
	);

	return (
		<Table.Row className={styles.rowHeader}>
			<Table.Cell className={`${styles.cellAlignLeft} ${styles.rowHeaderCell}`}>
				<span className={styles.bold}>{"Total Direct Costs"}</span>
			</Table.Cell>
			{Object.entries(costsByPeriod).map(([ p, costForPeriod ]) => (
				<Table.Cell className={`${styles.cellAlignRight} ${styles.rowHeaderCell}`} key={`period-${p}`}>
					<span className={styles.bold}>
						{currencyFormatter(costForPeriod)}
					</span>
				</Table.Cell>
			))}
			<Table.Cell className={`${styles.cellAlignRight} ${styles.rowHeaderCell}`}>
				<span className={styles.bold}>{currencyFormatter(total)}</span>
			</Table.Cell>
		</Table.Row>
	);
};
